/**
 * bookContent — 本のページ内容の定義。ページを差し替えたい時はこのファイルだけ編集する。
 *
 * faces は 面1〜面10（表紙をめくった左ページ 〜 裏表紙の手前）の配列。
 *   面1 = 最初の見開きの左ページ、面2 = その右ページ、面3 = 次の見開きの左…と続く。
 *   定義しなかった面は番号入りのプレースホルダーになる。
 *
 * 面の type:
 *   { type: 'image', source: 'bookTech0' }
 *     - source は sources.js に登録した texture の name。
 *       画像は contain（切らず全体表示・余白は紙色）でページに収まる。
 *   { type: 'text', title: '...', items: [{ label: '...', value: '...' }, ...] }
 *     - タイトル + ラベル/本文の組を縦に並べる。長文は自動で折り返される。
 */
export const BOOK_CONTENT = {
  cover: { title: 'MY WORKS', subtitle: 'Portfolio' },
  backCover: { title: 'THE END' },
  faces: [
    // 面1: 技術書展の写真
    { type: 'image', source: 'bookTech0' },
    // 面2: 技術書展の紹介
    {
      type: 'text',
      title: '技術書展20',
      items: [
        { label: '日時', value: '4/12' },
        { label: '内容', value: 'XREAL1Sを利用した開発について執筆しました！楽しかった！' },
      ],
    },
    // 面3・面4: 使用している 3D モデルのライセンス表記
    {
      type: 'text',
      title: 'LICENSES',
      items: [
        { label: 'alien in green spaceship', value: 'by Taylor Wilson [CC-BY] via Poly Pizza' },
        { label: 'Alien Jetpack Go!', value: 'by Damon Pidhajecky [CC-BY] via Poly Pizza' },
        { label: 'Flying saucer', value: 'by Poly by Google [CC-BY] via Poly Pizza' },
      ],
    },
    {
      // タイトルなし（面3の LICENSES の続き）
      type: 'text',
      items: [
        { label: 'Satellite', value: 'by Poly by Google [CC-BY] via Poly Pizza' },
        { label: 'Telescope', value: 'by Don Carson [CC-BY] via Poly Pizza' },
        {
          label: 'Space Ame Camping - Amelia Watson Hololive',
          value: 'by Seafoam [CC BY-NC 4.0] via Sketchfab (skfb.ly/o7Jww)',
        },
        { label: 'Simpsons TV', value: 'by CLWilliamson [CC-BY]' },
      ],
    },
    // 面5以降は未定義 = プレースホルダー
  ],
}
